module.exports = __webpack_public_path__ + "img/mnclogo.8da0577e.png";